var map = {
	"./assert.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/assert.d.ts",
	"./async_hooks.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/async_hooks.d.ts",
	"./base.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/base.d.ts",
	"./buffer.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/buffer.d.ts",
	"./child_process.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/child_process.d.ts",
	"./cluster.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/cluster.d.ts",
	"./console.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/console.d.ts",
	"./constants.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/constants.d.ts",
	"./crypto.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/crypto.d.ts",
	"./dgram.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/dgram.d.ts",
	"./dns.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/dns.d.ts",
	"./domain.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/domain.d.ts",
	"./events.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/events.d.ts",
	"./fs.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/fs.d.ts",
	"./fs/promises.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/fs/promises.d.ts",
	"./globals.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/globals.d.ts",
	"./globals.global.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/globals.global.d.ts",
	"./http.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/http.d.ts",
	"./http2.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/http2.d.ts",
	"./https.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/https.d.ts",
	"./index.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/index.d.ts",
	"./inspector.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/inspector.d.ts",
	"./module.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/module.d.ts",
	"./net.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/net.d.ts",
	"./os.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/os.d.ts",
	"./path.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/path.d.ts",
	"./perf_hooks.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/perf_hooks.d.ts",
	"./process.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/process.d.ts",
	"./punycode.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/punycode.d.ts",
	"./querystring.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/querystring.d.ts",
	"./readline.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/readline.d.ts",
	"./repl.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/repl.d.ts",
	"./stream.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/stream.d.ts",
	"./string_decoder.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/string_decoder.d.ts",
	"./timers.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/timers.d.ts",
	"./tls.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/tls.d.ts",
	"./trace_events.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/trace_events.d.ts",
	"./ts3.4/assert.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.4/assert.d.ts",
	"./ts3.4/base.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.4/base.d.ts",
	"./ts3.4/globals.global.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.4/globals.global.d.ts",
	"./ts3.4/index.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.4/index.d.ts",
	"./ts3.6/base.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.6/base.d.ts",
	"./ts3.6/index.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/ts3.6/index.d.ts",
	"./tty.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/tty.d.ts",
	"./url.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/url.d.ts",
	"./util.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/util.d.ts",
	"./v8.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/v8.d.ts",
	"./vm.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/vm.d.ts",
	"./wasi.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/wasi.d.ts",
	"./worker_threads.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/worker_threads.d.ts",
	"./zlib.d.ts": "./node_modules/raw-loader/dist/cjs.js!./node_modules/@types/node/zlib.d.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/@types/node sync recursive !!./node_modules/raw-loader/dist/cjs.js! \\.d.ts$";